import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TrucksService, MobileTrackerDevice } from 'src/app/transportation/trucks/trucks.service';
import { ActivatedRoute } from '@angular/router';
import { PgMessagesService, MessageLevel } from 'src/app/shared/services/pg-messages.service';
import { forkJoin } from 'rxjs';
import { DateTimeHelpers } from 'src/app/shared/helpers/date-time.helpers';
import { PgTitleComponent } from '../../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';

@Component({
  selector: 'app-gps-data-entry',
  templateUrl: './gps-data-entry.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    MatSelectModule,
    MatButtonModule,
    MaterialPgInputComponent,
    MaterialAutoCompleteComponent,
  ],
})
export class GpsDataEntryComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();
  history: any[] = [];
  selectedTracker: MobileTrackerDevice =  {
    imei: '',
    mobileNumber: '',
    trackerType: '',
  };
  selectedRegistrationNumber?: string;
  edit: boolean = false;
  associatedObjectList: any[] = [];
  typeList: string[] = ['quota', 'sold', 'stored'];
  trackerTypes: string[] = ['VenusProvider', 'JupiterProvider', 'KvlProvider'];

  constructor(private _truckService: TrucksService,
              private _activateRoute: ActivatedRoute,
              private _pgMessagesService: PgMessagesService) { }

  ngOnInit() {
    this.title.emit('Tracker');
    this._activateRoute.paramMap.subscribe(p => {
      if (p.get('imei')) {
        this.edit = true;
        this.selectedRegistrationNumber = p.get('imei') || undefined;
        forkJoin([
          this._truckService.getOneTracker(this.selectedRegistrationNumber || ''),
          this._truckService.getTrackerHistory(this.selectedRegistrationNumber || '')
        ]).subscribe(t => {
          this.selectedTracker = t[0];
          this.history = t[1];
        });
      }
    });
  }
  dateFormatter(timestamp: number) {
    if(timestamp !== 0) {
      return DateTimeHelpers.formatPersianLocalDate(timestamp);
    }
  }

  trackerTypeFormatter(trackerType: string) {
    if (trackerType === 'VenusProvider') {
      return 'ونوس';
    }
    else if (trackerType === 'JupiterProvider') {
      return '|ژوپیتر';
    }
    else if (trackerType === 'KvlProvider') {
      return 'کاوِل';
    }
    return '';
  }

  save() {
    if (!this.edit) {
      this.edit = false;
      this._truckService.addTracker(this.selectedTracker).subscribe(() => {
        this._pgMessagesService.publishMessage({
          message: `Tracker No ${this.selectedTracker.imei} Imported`,
          topic: 'New Tracker',
          level: MessageLevel.Info
        });
      }, () => {
        this._pgMessagesService.publishMessage({
          message: 'Error',
          topic: 'Conflict',
          level: MessageLevel.Error
        });
      });
    } else if (this.edit) {
      this.edit = true;
      this._truckService.updateTracker(this.selectedTracker).subscribe(() => {
        this._pgMessagesService.publishMessage({
          message: `Tracker No ${this.selectedTracker.imei} Edit`,
          topic: 'Edit Tracker',
          level: MessageLevel.Info
        });
      }, () => {
        this._pgMessagesService.publishMessage({
          message: 'Error',
          topic: 'Tracker Insertion Error',
          level: MessageLevel.Error
        });
      });
    }
  }
}
